import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
export class ModalConfirmComponent {
    constructor() {
        // Input
        this.title = "";
        this.contentText = "";
        this.acceptButtonText = "Aceptar";
        this.cancelButtonText = "Cancelar";
        // Output
        this.onAccept = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.loading = false;
        this.processing = false;
    }
    ngOnInit() {
    }
    /********* SHOW/HIDE *********/
    show(acceptCallback = null, cancelCallback = null) {
        this.acceptCallback = acceptCallback;
        this.cancelCallback = cancelCallback;
        this.modalConfirm.show();
    }
    showWithInlineConfig(title, contentText, acceptCallback = null, cancelCallback = null) {
        this.title = title;
        this.contentText = contentText;
        this.acceptCallback = acceptCallback;
        this.cancelCallback = cancelCallback;
        this.modalConfirm.show();
    }
    hide() {
        this.modalConfirm.hide();
        return new Promise(resolve => {
            setTimeout(() => {
                this.processing = false;
            }, 1000);
        });
        //this.processing = false
    }
    /********* SHOW/HIDE *********/
    /********* OPERATIONS *********/
    accept() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.processing = true;
            if (this.acceptCallback) {
                this.acceptCallback();
            }
            console.log("Carga");
            this.onAccept.emit();
            yield this.hide();
        });
    }
    cancel() {
        if (this.cancelCallback)
            this.cancelCallback();
        this.onCancel.emit();
        this.hide();
    }
}
